<template>
	<div v-once class="bots-not-allowed">
		<div class="bots-not-allowed__content">
			<h1>Bots Not Allowed</h1>
			<p>This application does not support bots.</p>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.bots-not-allowed {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	z-index: 1000;
	background-color: #f5f5f5;
	height: 100vh;
	color: #333;
	text-align: center;

	.bots-not-allowed__content {
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		border-radius: 8px;
		background-color: #fff;
		padding: 20px;
		max-width: 600px;

		h1 {
			margin-bottom: 10px;
			font-size: 2rem;
		}

		p {
			margin-bottom: 10px;
			font-size: 1rem;
		}
	}
}
</style>
